<template>
  <div>
    <el-dialog
      title=""
      center
      :visible.sync="visible"
      width="460px"
      :before-close="handleClose"
      append-to-body
    >
      <template slot="title">
        <div>选择仓库</div>
      </template>
      <el-form :model="form" ref="formRef" label-width="100px" size="mini">
        <el-form-item
          label="仓库"
          prop="stash_id"
          :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
        >
          <el-select v-model="form.stash_id" filterable placeholder="请选择">
            <el-option
              v-for="item in stashArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="primary"  @click="confirm">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["stashArr",'oneOrmore'],
  data() {
    return {
      visible: false,
      form: {
        stash_id: "",
      },
      row:null, 
    };
  },
  methods: {
    getDetails(row) {
      this.row = row;
    },
    toggle(show) {
      this.visible = show;
      // this.$refs.formRef.clearValidate();
      !show && this.reset();
    },
    reset(done) {
      this.form.stash_id = "";
      this.row = null;
      done && done();
    },
    handleClose() {
      this.toggle(false)
    },
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("stashidialogConfirm", this.form.stash_id,this.row,this.oneOrmore);
          this.toggle(false)
        } else {
          return false;
        }
      });
    },
  },
};
</script>